







import { defineComponent } from '@vue/composition-api';
import { FitIcon } from '@tencent/wphk-ui';

export default defineComponent({
  name: 'BottomTips',
  props: {
    /** 是否展示icon */
    isShowIcon: {
      type: Boolean,
    },
    /** 文案 */
    tips: {
      type: String,
    },
  },
  components: {
    FitIcon,
  },
});

